<ng-container *ngFor="let key of dataKeys">
  <ng-container *ngIf="formGroupData" [formGroupName]="schemaData[key].formGroupData">
    <div nz-col class="gutter-row" [nzSpan]="
        schemaData[key]?.option && schemaData[key]?.option.span
          ? schemaData[key]?.option.span
          : '12'
      "  *ngIf="!schemaData[key].hidden && (tabname? schemaData[key].tabs.split(',').includes(tabname):true) && schemaData[key]?.componentType" style="padding: 0px 10px 0px 10px">
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.SELECT">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="selectCodeCheck">
          <nz-select [nzMode]="getNzMode(schemaData[key]?.option?.mode)"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" name="select-error" id="{{ key }}" formControlName="{{ key }}" nzShowSearch nzAllowClear>
            <ng-container *ngIf="schemaData[key]?.option?.optionsData">
              <nz-option *ngFor="let option of schemaData[key]?.option?.optionsData"
                [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData
              ">
              <nz-option *ngFor="
                  let option of (
                    formData[schemaData[key]?.option.data] | async
                  ).get(schemaData[key]?.option.key)
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                !schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData
              ">
              <nz-option *ngFor="
                  let option of (formData[schemaData[key]?.option.data] | async)[
                    schemaData[key]?.option.key
                  ]
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
              </nz-option>
            </ng-container>
          </nz-select>
          <ng-template #selectCodeCheck>
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.SELECTICON">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="selectCodeCheck">
          <nz-select [nzMode]="getNzMode(schemaData[key]?.option?.mode)"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" name="select-error" id="{{ key }}" formControlName="{{ key }}" nzShowSearch nzAllowClear [nzCustomTemplate]="defaultTemplate">
            <ng-container *ngIf="schemaData[key]?.option?.optionsData">
              <nz-option nzCustomContent *ngFor="let option of schemaData[key]?.option?.optionsData"
                [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
                <svg height="14px" width="20px" class="mr-md">
                  <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+option?.code }}"></use>
                </svg> {{option[schemaData[key]?.option.label]}}
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData
              ">
              <nz-option nzCustomContent *ngFor="
                  let option of (
                    formData[schemaData[key]?.option.data] | async
                  ).get(schemaData[key]?.option.key)
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
                <svg height="14px" width="20px" class="mr-md">
                  <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+option?.code}}"></use>
                </svg> {{option[schemaData[key]?.option.label]}}
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                !schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData
              ">
              <nz-option nzCustomContent *ngFor="
                  let option of (formData[schemaData[key]?.option.data] | async)[
                    schemaData[key]?.option.key
                  ]
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
                <svg height="14px" width="20px" class="mr-md">
                  <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+option?.code}}"></use>
                </svg> {{option[schemaData[key]?.option.label]}}
              </nz-option>
            </ng-container>
          </nz-select>
          <ng-template #selectCodeCheck>
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
          <ng-template #defaultTemplate let-selected>
            <svg height="14px" width="20px" class="mr-md">
              <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+selected.nzValue}}"></use>
            </svg>
            {{ selected.nzLabel }}
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.INPUT">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control class="formContol" [nzErrorTip]="inputCodeCheck">
          <input nz-input
            placeholder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            [allowAlphaNumeric]="
              schemaData[key]?.option && schemaData[key]?.option.alphaNumeric
            " [onlyNumberValidation]="
              schemaData[key]?.option && schemaData[key]?.option.numberValidation
            " [allowDecimalValue]="
              schemaData[key]?.option && schemaData[key]?.option.allowDecimalValue
            " id="{{ key }}" formControlName="{{ key }}" />
        </nz-form-control>
        <ng-template #inputCodeCheck>
          <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
        </ng-template>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.INPUTNUMBER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control class="formContol" [nzErrorTip]="inputNumberCodeCheck">
          <nz-input-number
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            style="width: 100%" formControlName="{{ key }}" id="{{ key }}" [nzStep]="schemaData[key]?.option.step"
            [onlyNumberValidation]="
              schemaData[key]?.option && schemaData[key]?.option.numberValidation
            "></nz-input-number>
        </nz-form-control>
        <ng-template #inputNumberCodeCheck>
          <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
        </ng-template>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.TEXTAREA">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="textAreaCheck">
          <nz-textarea-count [nzMaxCharacterCount]="schemaData[key]?.option?.maxlength">
            <textarea
              placeholder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
              id="{{ key }}" formControlName="{{ key }}" nz-input></textarea>
          </nz-textarea-count>
        </nz-form-control>
        <ng-template #textAreaCheck class="errorMessage">
          <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
        </ng-template>
        <small *ngIf="schemaData[key]?.option?.showMsg"><code>{{ f[key]?.value?.length || 0 }}</code>
          {{ "app.label.of" | translate }}
          <code>{{ schemaData[key]?.validations["size-max"] }}</code>
          characters</small>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.DATEPICKER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="dateRangeCheck">
          <nz-date-picker formControlName="{{ key }}" id="{{ key }}" [nzFormat]="schemaData[key]?.option.format"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder }}"
            [nzDisabledDate]="functionList[schemaData[key]?.option.disabledDate]"
            [nzDisabledTime]="functionList[schemaData[key]?.option.disabledTime]"
            [nzShowTime]="schemaData[key]?.option?.timeFormat  ? {nzFormat : schemaData[key]?.option?.timeFormat} : (schemaData[key]?.option?.showTime ? schemaData[key]?.option?.showTime :false)">
          </nz-date-picker>
        </nz-form-control>
        <ng-template #dateRangeCheck class="errorMessage">
          <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
        </ng-template>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.DATERANGEPICKER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control>
          <!-- <nz-range-picker nzDropdownClassName="{{key}}" [nzFormat]="schemaData[key]?.option.format" id="{{key}}" [ngModelOptions]="{ standalone: true }" [(ngModel)]="dateRange" [nzRanges]="dateRangeExtra" ></nz-range-picker> -->

          <nz-range-picker nzDropdownClassName="{{ key }}" [nzFormat]="schemaData[key]?.option.format" id="{{ key }}"
            [ngModelOptions]="schemaData[key]?.option.modelOptions" [(ngModel)]="schemaData[key].option.model" [nzRanges]="dateRangeExtra"
            (ngModelChange)="
              functionList[schemaData[key]?.option.onChange]($event)
            "></nz-range-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.YEARPICKER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control>
          <nz-year-picker
          nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" formControlName="{{ key }}"></nz-year-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.RADIO">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control>
          <nz-radio-group formControlName="{{ key }}">
            <label nz-radio *ngFor="let option of schemaData[key]?.option?.optionsData"
              [nzValue]="option[schemaData[key]?.option.value]">{{ option[schemaData[key]?.option.label] }}</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.LOOKUP">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="errorTplhsCode">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
            <input
              placeholder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
              nz-input id="{{ key }}" formControlName="{{ key }}" />
          </nz-input-group>
          <ng-template #suffixIconButton>
            <button type="button" nz-button nzType="primary" [disabled]="schemaData[key]?.option.disabled" nzSearch
              (click)="functionList[schemaData[key]?.option.click]()">
              <i nz-icon nzType="search"></i>
              {{ "app.label.lookup" | translate }}
            </button>
          </ng-template>
          <ng-template #errorTplhsCode let-control>
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.SELECT_SEARCH">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="productCodeCheck">
          <nz-select [nzMode]="getNzMode(schemaData[key]?.option?.mode)"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" formControlName="{{ key }}" nzPlaceHolder="{{ schemaData[key]?.option?.placeholder }}"
            nzAllowClear nzShowSearch nzServerSearch (nzOnSearch)="
              functionList[schemaData[key]?.option.onSearchEvent]($event)
            ">
            <ng-container *ngFor="let option of schemaData[key]?.option?.optionsData">
              <nz-option *ngIf="!schemaData[key]?.option.showLoader" [nzValue]="option[schemaData[key]?.option.value]"
                [nzLabel]="option[schemaData[key]?.option.label]"></nz-option>
            </ng-container>
            <nz-option *ngIf="schemaData[key]?.option.showLoader" nzDisabled nzCustomContent>
              <i nz-icon nzType="loading" class="loading-icon"></i> Loading
              Data...
            </nz-option>
          </nz-select>
          <ng-template #productCodeCheck class="errorMessage">
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.POPUP_VIEW">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="inputGroupCheck">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
            <input formControlName="{{ key }}" placeholder="{{ schemaData[key]?.option?.placeholder }}" id="{{ key }}"
              nz-input />
          </nz-input-group>
          <ng-template #suffixIconButton>
            <button nzType="default" type="button" id="{{ key + 'Create' }}" nz-button
              (click)="functionList[schemaData[key]?.option.click](key)">
              <i nz-icon nzType="search"></i>
            </button>
          </ng-template>
          <ng-template #inputGroupCheck class="errorMessage">
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-container>
  <ng-container *ngIf="!formGroupData">
    <div nz-col class="gutter-row" [nzSpan]="
        schemaData[key]?.option && schemaData[key]?.option.span
          ? schemaData[key]?.option.span
          : 12
      " *ngIf="!schemaData[key].hidden && (tabname? schemaData[key].tabs.split(',').includes(tabname):true) && schemaData[key]?.componentType" style="padding: 0px 10px 0px 10px">
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.SELECT">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="selectCodeCheck">
          <nz-select [nzMode]="getNzMode(schemaData[key]?.option?.mode)"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" name="select-error" id="{{ key }}" formControlName="{{ key }}" nzShowSearch nzAllowClear>
            <ng-container *ngIf="schemaData[key]?.option?.optionsData">
              <nz-option *ngFor="let option of schemaData[key]?.option?.optionsData"
                [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData
              ">
              <nz-option *ngFor="
                  let option of (
                    formData[schemaData[key]?.option.data] | async
                  ).get(schemaData[key]?.option.key)
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                !schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData &&
                schemaData[key]?.option.key
              ">
              <nz-option *ngFor="
                  let option of (formData[schemaData[key]?.option.data] | async)[
                    schemaData[key]?.option.key
                  ]
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                !schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData &&
                !schemaData[key]?.option.key
              ">
              <nz-option *ngFor="
                  let option of formData[schemaData[key]?.option.data] | async
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
              </nz-option>
            </ng-container>
          </nz-select>
          <ng-template #selectCodeCheck>
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.SELECTICON">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="selectCodeCheck">
          <nz-select [nzMode]="getNzMode(schemaData[key]?.option?.mode)"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" name="select-error" id="{{ key }}" formControlName="{{ key }}" nzShowSearch nzAllowClear [nzCustomTemplate]="defaultTemplate">
            <ng-container *ngIf="schemaData[key]?.option?.optionsData">
              <nz-option nzCustomContent *ngFor="let option of schemaData[key]?.option?.optionsData"
                [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
                <svg height="14px" width="20px" class="mr-md">
                  <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+option?.code}}"></use>
                </svg> {{option[schemaData[key]?.option.label]}}
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData
              ">
              <nz-option nzCustomContent *ngFor="
                  let option of (
                    formData[schemaData[key]?.option.data] | async
                  ).get(schemaData[key]?.option.key)
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
                <svg height="14px" width="20px" class="mr-md">
                  <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+option?.code}}"></use>
                </svg> {{option[schemaData[key]?.option.label]}}
              </nz-option>
            </ng-container>

            <ng-container *ngIf="
                !schemaData[key]?.refTypeCode &&
                !schemaData[key]?.option?.optionsData
              ">
              <nz-option nzCustomContent *ngFor="
                  let option of (formData[schemaData[key]?.option.data] | async)[
                    schemaData[key]?.option.key
                  ]
                " [nzLabel]="option[schemaData[key]?.option.label]" [nzValue]="option[schemaData[key]?.option.value]">
                <svg height="14px" width="20px" class="mr-md">
                  <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+option?.code}}"></use>
                </svg> {{option[schemaData[key]?.option.label]}}
              </nz-option>
            </ng-container>
          </nz-select>
          <ng-template #selectCodeCheck>
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
          <ng-template #defaultTemplate let-selected>
            <svg height="14px" width="20px" class="mr-md">
              <use attr.xlink:href="{{'/assets/outline/countryFlag.svg#icon-'+selected.nzValue}}"></use>
            </svg>
            {{ selected.nzLabel }}
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.INPUT">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control class="formContol" [nzErrorTip]="inputCodeCheck">
          <input
            placeholder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            nz-input [allowAlphaNumeric]="
              schemaData[key]?.option && schemaData[key]?.option.alphaNumeric
            " [onlyNumberValidation]="
              schemaData[key]?.option && schemaData[key]?.option.numberValidation
            " [allowDecimalValue]="
              schemaData[key]?.option && schemaData[key]?.option.allowDecimalValue
            " id="{{ key }}" formControlName="{{ key }}" />
        </nz-form-control>
        <ng-template #inputCodeCheck>
          <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
        </ng-template>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.INPUTNUMBER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control class="formContol" [nzErrorTip]="inputNumberCodeCheck">
          <nz-input-number
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            style="width: 100%" formControlName="{{ key }}" id="{{ key }}" [nzStep]="schemaData[key]?.option.step"
            [onlyNumberValidation]="
              schemaData[key]?.option && schemaData[key]?.option.numberValidation
            " [allowDecimalValue]="
            schemaData[key]?.option && schemaData[key]?.option.allowDecimalValue
          "></nz-input-number>
        </nz-form-control>
        <ng-template #inputNumberCodeCheck>
          <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
        </ng-template>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.TEXTAREA">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="textAreaCheck">
          <nz-textarea-count [nzMaxCharacterCount]="schemaData[key]?.option?.maxlength">
            <textarea
              placeholder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
              id="{{ key }}" formControlName="{{ key }}" nz-input></textarea>
          </nz-textarea-count>
        </nz-form-control>
        <ng-template #textAreaCheck class="errorMessage">
          <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
        </ng-template>
        <small *ngIf="schemaData[key]?.option?.showMsg"><code>{{ f[key]?.value?.length || 0 }}</code>
          {{ "app.label.of" | translate }}
          <code>{{ schemaData[key]?.validations["size-max"] }}</code>
          characters</small>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.DATEPICKER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="dateRangeCheck">
          <nz-date-picker formControlName="{{ key }}" id="{{ key }}" [nzFormat]="schemaData[key]?.option.format"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder }}"
            [nzDisabledDate]="schemaData[key]?.option.disabledDate ? functionList[schemaData[key]?.option.disabledDate]: disabledDate"
            [nzDisabledTime]="schemaData[key]?.option.disabledTime ? functionList[schemaData[key]?.option.disabledTime] : disableTime"
            [nzShowTime]="schemaData[key]?.option?.timeFormat  ? {nzFormat : schemaData[key]?.option?.timeFormat} : (schemaData[key]?.option?.showTime ? schemaData[key]?.option?.showTime :false)">
          </nz-date-picker>
          <ng-template #dateRangeCheck class="errorMessage">
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.DATERANGEPICKER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control>
          <nz-range-picker nzDropdownClassName="{{ key }}" [nzFormat]="schemaData[key]?.option.format" id="{{ key }}"
            [ngModelOptions]="schemaData[key]?.option.modelOptions" [(ngModel)]="schemaData[key].option.model" [nzRanges]="dateRangeExtra"
            (ngModelChange)="
              functionList[schemaData[key]?.option.onChange]($event)
            "></nz-range-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.YEARPICKER">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control>
          <nz-year-picker
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" formControlName="{{ key }}"></nz-year-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.RADIO">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control>
          <nz-radio-group formControlName="{{ key }}">
            <label nz-radio *ngFor="let option of schemaData[key]?.option?.optionsData"
              [nzValue]="option[schemaData[key]?.option.value]">{{ option[schemaData[key]?.option.label] }}</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.LOOKUP">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="errorTplhsCode">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
            <input
              placeholder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Enter ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
              nz-input id="{{ key }}" formControlName="{{ key }}" />
          </nz-input-group>
          <ng-template #suffixIconButton>
            <button type="button" nz-button nzType="primary" nzSearch [disabled]="schemaData[key]?.option.disabled"
              (click)="functionList[schemaData[key]?.option.click]()">
              <i nz-icon nzType="search"></i>
              {{ "app.label.lookup" | translate }}
            </button>
          </ng-template>
          <ng-template #errorTplhsCode let-control>
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.SELECT_SEARCH">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
        <nz-form-control [nzErrorTip]="productCodeCheck">
          <nz-select [nzMode]="getNzMode(schemaData[key]?.option?.mode)"
            nzPlaceHolder="{{ schemaData[key]?.option?.placeholder ? schemaData[key]?.option?.placeholder : 'Select ' + (schemaData[key].labels[schemaData[key]?.labelIndex ? schemaData[key].labelIndex : 0] | translate)}}"
            id="{{ key }}" formControlName="{{ key }}" nzPlaceHolder="{{ schemaData[key]?.option?.placeholder }}"
            nzAllowClear nzShowSearch nzServerSearch (nzOnSearch)="
              functionList[schemaData[key]?.option.onSearchEvent]($event)
            ">
            <ng-container *ngFor="let option of schemaData[key]?.option?.optionsData">
              <nz-option *ngIf="!schemaData[key]?.option.showLoader" [nzValue]="option[schemaData[key]?.option.value]"
                [nzLabel]="option[schemaData[key]?.option.label]"></nz-option>
            </ng-container>
            <nz-option *ngIf="schemaData[key]?.option.showLoader" nzDisabled nzCustomContent>
              <i nz-icon nzType="loading" class="loading-icon"></i> Loading
              Data...
            </nz-option>
          </nz-select>
          <ng-template #productCodeCheck class="errorMessage">
            <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item *ngIf="schemaData[key].componentType === componentTypes.POPUP_VIEW">
        <cargoes-form-label [labelName]="schemaData[key]" [labelIndex]="
            schemaData[key].labelIndex ? schemaData[key].labelIndex : 0
          "></cargoes-form-label>
          <nz-form-control [nzErrorTip]="inputGroupCheck">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
              <input formControlName="{{ key }}" placeholder="{{ schemaData[key]?.option?.placeholder }}" id="{{ key }}"
                nz-input />
            </nz-input-group>
            <ng-template #suffixIconButton>
              <button nzType="default" type="button" id="{{ key + 'Create' }}" nz-button
                (click)="functionList[schemaData[key]?.option.click](key)">
                <i nz-icon nzType="search"></i>
              </button>
            </ng-template>
            <ng-template #inputGroupCheck class="errorMessage">
              <span *ngFor="let error of formValidationService.getErrors(f[key]?.errors)"> {{ error | translate}}</span>
            </ng-template>
          </nz-form-control>
      </nz-form-item>
      <div *ngIf="schemaData[key]?.componentType === 'upload'">
        <nz-upload  nzType="drag" [nzMultiple]="schemaData[key]?.option?.multiple" [(nzFileList)]="fileList" [nzFileType]="schemaData[key]?.option.fileType" [nzBeforeUpload]="functionList[schemaData[key]?.option?.beforeUpload]" (nzChange)="functionList[schemaData[key]?.option?.onChange]($event)" [nzLimit]="schemaData[key]?.option?.limit" >
            <p class="ant-upload-drag-icon">
                <i nz-icon nzType="inbox"></i>
            </p>
            <p class="ant-upload-text">{{'app.label.drag.file.upload'|translate}}</p>
            <p class="ant-upload-hint">
                {{'app.label.drag.file.upload.desc'|translate}}
            </p>
        </nz-upload>
      </div>
    </div>
  </ng-container>
</ng-container>
